import AuthService from '../services/auth.service';

let user = JSON.parse(localStorage.getItem('user'));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

// eslint-disable-next-line import/prefer-default-export
export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, loginUser) {
      return AuthService.login(loginUser).then(
        (proccesedUser) => {
          commit('loginSuccess', proccesedUser);
          return Promise.resolve(proccesedUser);
        },
        (error) => {
          commit('loginFailure');
          return Promise.reject(error);
        },
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },

    recoverPassword({ commit }, email) {
      return AuthService.recoverPassword(email).then(
        () => {
          commit('recoverPasswordSuccess');
          return Promise.resolve();
        },
        (error) => {
          commit('recoverPasswordFailure');
          return Promise.reject(error);
        },
      );
    },

    register({ commit }, regUser) {
      return AuthService.register(regUser).then(
        (response) => {
          commit('registerSuccess');
          return Promise.resolve(response.data);
        },
        (error) => {
          commit('registerFailure');
          return Promise.reject(error);
        },
      );
    },
  },
  getters: {
    hasRole: (state) => (roleList) => {
      if (state.user) {
        const userRole = AuthService.getDecodedJwtToken(state.user).rol;
        return roleList.includes(userRole);
      }
      return false;
    },
  },
  mutations: {
    loginSuccess(state, loginUser) {
      state.status.loggedIn = true;
      state.user = loginUser;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
      user = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
  },
};
